import { externalConstraint } from '@flatfile/plugin-constraints'
import { recordkeeperListener, iraAmountValidator } from './listeners'
import {
  planEinFormattingListener,
  planSponsorFormattingListener,
  planNameFormattingListener,
  planIdNumberFormattingListener,
  zipCodeFormattingListener,
  planNumberFormattingListener,
  emailAddressValidationListener,
} from './participantsDataFormatting'
import {
  recordkeeperFormattingListener,
  countryCodeFormattingListener,
  stateFormattingListener,
  zipCodeValidationListener,
  balanceVestedFormattingAndValidationListener,
  balanceTotalFormattingAndValidationListener,
  dateOfBalanceFormattingListener,
  dateOfBalanceValidationListener,
  reasonForRolloutRequestFormattingListener,
  reasonForRolloutRequestValidationListener,
  gracePeriodForParticipantToRespondFormattingAndValidationListener,
  rolloutHelpCompanyStateFormattingAndValidationListener,
  rolloutHelpCompanyZipFormattingListener,
  rolloutHelpCompanyZipValidationListener,
  rolloutHelpCompanyEmailValidationListener,
} from './notificatonsDataFormatting'
import { notificationServicesFields } from '../config/notificationsFields'

export const notificationsParticipantListeners = (listener, userAudience) => {
  /*Data Formatting */

  // Recordkeeper formatting
  recordkeeperFormattingListener(listener, 'participant-record')
  // PlanEin formatting
  planEinFormattingListener(listener, 'participant-record')

  // PlanSponsor formatting
  planSponsorFormattingListener(listener, 'participant-record')

  // PlanName formatting
  planNameFormattingListener(listener, 'participant-record')

  //PlanIdNumber formatting
  planIdNumberFormattingListener(listener, 'participant-record')

  //PlanNumber formatting
  planNumberFormattingListener(listener, 'participant-record')

  //ZipCode formatting
  zipCodeFormattingListener(listener, 'participant-record')
  zipCodeValidationListener(listener, 'participant-record')

  //CountryCode formatting
  countryCodeFormattingListener(listener, 'participant-record')

  //State formatting
  stateFormattingListener(listener, 'participant-record')

  //Email Address validation
  emailAddressValidationListener(listener, 'participant-record')

  //Notification Specific validations and formattings
  balanceVestedFormattingAndValidationListener(listener, 'participant-record')
  balanceTotalFormattingAndValidationListener(listener, 'participant-record')
  dateOfBalanceFormattingListener(listener, 'participant-record')
  dateOfBalanceValidationListener(listener, 'participant-record')
  reasonForRolloutRequestFormattingListener(listener, 'participant-record')
  reasonForRolloutRequestValidationListener(listener, 'participant-record')
  gracePeriodForParticipantToRespondFormattingAndValidationListener(
    listener,
    'participant-record'
  )
  rolloutHelpCompanyStateFormattingAndValidationListener(
    listener,
    'participant-record'
  )
  rolloutHelpCompanyZipFormattingListener(listener, 'participant-record')
  rolloutHelpCompanyZipValidationListener(listener, 'participant-record')
  rolloutHelpCompanyEmailValidationListener(listener, 'participant-record')

  /*Data Validations */
  listener.use(
    externalConstraint('recordKeeper', (value, key, { config, record }) => {
      if (value && new RegExp(config.noSlashRegex.regex).test(value)) {
        record.addError(key, config.noSlashRegex.error)
      }
      if (
        value &&
        new RegExp(config.createMaxCharValidator.regex).test(value)
      ) {
        record.addError(key, config.createMaxCharValidator.error)
      }
      if (
        value &&
        new RegExp(config.createEmptyValueValidator.regex).test(value)
      ) {
        record.addError(key, config.createEmptyValueValidator.error)
      }
    })
  )

  recordkeeperListener(listener, 'participant-record')

  listener.use(
    externalConstraint('tpa', (value, key, { config, record }) => {
      if (value && new RegExp(config.noSlashRegex.regex).test(value)) {
        record.addError(key, config.noSlashRegex.error)
      }
      if (
        value &&
        new RegExp(config.createMaxCharValidator.regex).test(value)
      ) {
        record.addError(key, config.createMaxCharValidator.error)
      }
      if (userAudience !== 'Recordkeeper') {
        if (
          value &&
          new RegExp(config.createEmptyValueValidator.regex).test(value)
        ) {
          record.addError(key, config.createEmptyValueValidator.error)
        }
      }
    })
  )

  listener.use(
    externalConstraint('planSponsor', (value, key, { config, record }) => {
      if (value && new RegExp(config.noSlashRegex.regex).test(value)) {
        record.addError(key, config.noSlashRegex.error)
      }
      if (value && new RegExp(config.invalidString.regex, 'i').test(value)) {
        record.addError(key, config.invalidString.error)
      }
      if (
        value &&
        new RegExp(config.createMaxCharValidator.regex).test(value)
      ) {
        record.addError(key, config.createMaxCharValidator.error)
      }
      if (
        value &&
        new RegExp(config.createEmptyValueValidator.regex).test(value)
      ) {
        record.addError(key, config.createEmptyValueValidator.error)
      }
    })
  )

  listener.use(
    externalConstraint('planName', (value, key, { config, record }) => {
      if (value && new RegExp(config.noSlashRegex.regex).test(value)) {
        record.addError(key, config.noSlashRegex.error)
      }
      if (
        value &&
        new RegExp(config.createMaxCharValidator.regex).test(value)
      ) {
        record.addError(key, config.createMaxCharValidator.error)
      }
      if (
        value &&
        new RegExp(config.createEmptyValueValidator.regex).test(value)
      ) {
        record.addError(key, config.createEmptyValueValidator.error)
      }
    })
  )

  listener.use(
    externalConstraint('planEin', (value, key, { config, record }) => {
      if (value && !new RegExp(config.invalidEINFormat.regex).test(value)) {
        record.addError(key, config.invalidEINFormat.error)
      }
      if (value && !new RegExp(config.invalidEIN.regex).test(value)) {
        record.addError(key, config.invalidEIN.error)
      }
    })
  )

  listener.use(
    externalConstraint('planNumber', (value, key, { config, record }) => {
      if (value && new RegExp(config.invalidCharacters.regex).test(value)) {
        record.addError(key, config.invalidCharacters.error)
      }
      if (value && !new RegExp(config.mustBeThreeDigits.regex).test(value)) {
        record.addError(key, config.mustBeThreeDigits.error)
      }
    })
  )

  listener.use(
    externalConstraint('planIdNumber', (value, key, { config, record }) => {
      if (
        value &&
        new RegExp(config.createMaxCharValidator.regex).test(value)
      ) {
        record.addError(key, config.createMaxCharValidator.error)
      }
    })
  )

  listener.use(
    externalConstraint('firstName', (value, key, { config, record }) => {
      if (
        value &&
        new RegExp(config.createMaxCharValidator.regex).test(value)
      ) {
        record.addError(key, config.createMaxCharValidator.error)
      }
      if (value && new RegExp(config.checkNamePrefix.regex, 'i').test(value)) {
        record.addError(key, config.checkNamePrefix.error)
      }
      if (
        value &&
        new RegExp(config.checkNotApplicable.regex, 'i').test(value)
      ) {
        record.addError(key, config.checkNotApplicable.error)
      }
      if (
        value &&
        new RegExp(config.createEmptyValueValidator.regex).test(value)
      ) {
        record.addError(key, config.createEmptyValueValidator.error)
      }
    })
  )

  listener.use(
    externalConstraint('middleName', (value, key, { config, record }) => {
      if (
        value &&
        new RegExp(config.createMaxCharValidator.regex).test(value)
      ) {
        record.addError(key, config.createMaxCharValidator.error)
      }
    })
  )

  listener.use(
    externalConstraint('lastName', (value, key, { config, record }) => {
      if (
        value &&
        new RegExp(config.createMaxCharValidator.regex).test(value)
      ) {
        record.addError(key, config.createMaxCharValidator.error)
      }
      if (
        value &&
        new RegExp(config.checkNotApplicable.regex, 'i').test(value)
      ) {
        record.addError(key, config.checkNotApplicable.error)
      }
      if (
        value &&
        new RegExp(config.createEmptyValueValidator.regex).test(value)
      ) {
        record.addError(key, config.createEmptyValueValidator.error)
      }
    })
  )

  listener.use(
    externalConstraint('addressLine1', (value, key, { config, record }) => {
      if (
        value &&
        new RegExp(config.createMaxCharValidator.regex).test(value)
      ) {
        record.addError(key, config.createMaxCharValidator.error)
      }
      if (
        value &&
        new RegExp(config.checkNotApplicable.regex, 'i').test(value)
      ) {
        record.addError(key, config.checkNotApplicable.error)
      }
      if (
        value &&
        new RegExp(config.createEmptyValueValidator.regex).test(value)
      ) {
        record.addError(key, config.createEmptyValueValidator.error)
      }
    })
  )

  listener.use(
    externalConstraint('addressLine2', (value, key, { config, record }) => {
      if (
        value &&
        new RegExp(config.createMaxCharValidator.regex).test(value)
      ) {
        record.addError(key, config.createMaxCharValidator.error)
      }
    })
  )

  listener.use(
    externalConstraint('city', (value, key, { config, record }) => {
      if (
        value &&
        new RegExp(config.createMaxCharValidator.regex).test(value)
      ) {
        record.addError(key, config.createMaxCharValidator.error)
      }
      if (
        value &&
        new RegExp(config.createEmptyValueValidator.regex).test(value)
      ) {
        record.addError(key, config.createEmptyValueValidator.error)
      }
    })
  )

  listener.use(
    externalConstraint('state', (value, key, { config, record }) => {
      if (
        value &&
        new RegExp(config.createMaxCharValidator.regex).test(value)
      ) {
        record.addError(key, config.createMaxCharValidator.error)
      }
      if (
        value &&
        new RegExp(config.createEmptyValueValidator.regex).test(value)
      ) {
        record.addError(key, config.createEmptyValueValidator.error)
      }
    })
  )

  listener.use(
    externalConstraint('zipCode', (value, key, { config, record }) => {
      if (
        value &&
        new RegExp(config.createMaxCharValidator.regex).test(value)
      ) {
        record.addError(key, config.createMaxCharValidator.error)
      }
      if (
        value &&
        new RegExp(config.createEmptyValueValidator.regex).test(value)
      ) {
        record.addError(key, config.createEmptyValueValidator.error)
      }
    })
  )

  listener.use(
    externalConstraint('countryCode', (value, key, { config, record }) => {
      if (
        value &&
        new RegExp(config.createEmptyValueValidator.regex).test(value)
      ) {
        record.addError(key, config.createEmptyValueValidator.error)
      }
      if (
        value &&
        new RegExp(config.createEmptyValueValidator.regex).test(value)
      ) {
        record.addError(key, config.createEmptyValueValidator.error)
      }
    })
  )

  listener.use(
    externalConstraint('emailAddress', (value, key, { config, record }) => {
      if (
        value &&
        new RegExp(config.createMaxCharValidator.regex).test(value)
      ) {
        record.addError(key, config.createMaxCharValidator.error)
      }
    })
  )

  listener.use(
    externalConstraint(
      notificationServicesFields.BAL_VESTED.key,
      (value, key, { config, record }) => {
        if (
          value &&
          new RegExp(config.createMaxCharValidator.regex).test(value)
        ) {
          record.addError(key, config.createMaxCharValidator.error)
        }
      }
    )
  )

  listener.use(
    externalConstraint(
      notificationServicesFields.BAL_TOTAL.key,
      (value, key, { config, record }) => {
        if (
          value &&
          new RegExp(config.createMaxCharValidator.regex).test(value)
        ) {
          record.addError(key, config.createMaxCharValidator.error)
        }
      }
    )
  )

  listener.use(
    externalConstraint(
      notificationServicesFields.REASON_ROLLOUT_REQ.key,
      (value, key, { config, record }) => {
        if (
          value &&
          !new RegExp(config.reasonRolloutReq.regex, 'i').test(value)
        ) {
          record.addError(key, config.reasonRolloutReq.error)
        }
      }
    )
  )

  listener.use(
    externalConstraint(
      notificationServicesFields.GRACE_PERIOD_TO_RESPOND.key,
      (value, key, { config, record }) => {
        if (
          value &&
          !new RegExp(config.gracePeriodToRespond.regex, 'i').test(value)
        ) {
          record.addError(key, config.gracePeriodToRespond.error)
        }
      }
    )
  )

  listener.use(
    externalConstraint(
      notificationServicesFields.COMPANY_NAME.key,
      (value, key, { config, record }) => {
        if (value && new RegExp(config.noSlashRegex.regex).test(value)) {
          record.addError(key, config.noSlashRegex.error)
        }
        if (
          value &&
          new RegExp(config.createMaxCharValidator.regex).test(value)
        ) {
          record.addError(key, config.createMaxCharValidator.error)
        }
        if (
          value &&
          new RegExp(config.createEmptyValueValidator.regex).test(value)
        ) {
          record.addError(key, config.createEmptyValueValidator.error)
        }
      }
    )
  )

  listener.use(
    externalConstraint(
      notificationServicesFields.COMPANY_ADDRESS_1.key,
      (value, key, { config, record }) => {
        if (
          value &&
          new RegExp(config.createMaxCharValidator.regex).test(value)
        ) {
          record.addError(key, config.createMaxCharValidator.error)
        }
        if (
          value &&
          new RegExp(config.createNotApplicableValidator.regex).test(value)
        ) {
          record.addError(key, config.createNotApplicableValidator.error)
        }
        if (
          value &&
          new RegExp(config.createEmptyValueValidator.regex).test(value)
        ) {
          record.addError(key, config.createEmptyValueValidator.error)
        }
      }
    )
  )

  listener.use(
    externalConstraint(
      notificationServicesFields.COMPANY_ADDRESS_2.key,
      (value, key, { config, record }) => {
        if (
          value &&
          new RegExp(config.createMaxCharValidator.regex).test(value)
        ) {
          record.addError(key, config.createMaxCharValidator.error)
        }
      }
    )
  )

  listener.use(
    externalConstraint(
      notificationServicesFields.COMPANY_CITY.key,
      (value, key, { config, record }) => {
        if (
          value &&
          new RegExp(config.createMaxCharValidator.regex).test(value)
        ) {
          record.addError(key, config.createMaxCharValidator.error)
        }
        if (
          value &&
          new RegExp(config.createEmptyValueValidator.regex).test(value)
        ) {
          record.addError(key, config.createEmptyValueValidator.error)
        }
      }
    )
  )

  listener.use(
    externalConstraint(
      notificationServicesFields.COMPANY_STATE.key,
      (value, key, { config, record }) => {
        if (
          value &&
          new RegExp(config.createMaxCharValidator.regex).test(value)
        ) {
          record.addError(key, config.createMaxCharValidator.error)
        }
        if (
          value &&
          new RegExp(config.createEmptyValueValidator.regex).test(value)
        ) {
          record.addError(key, config.createEmptyValueValidator.error)
        }
      }
    )
  )

  listener.use(
    externalConstraint(
      notificationServicesFields.COMPANY_ZIP.key,
      (value, key, { config, record }) => {
        if (
          value &&
          new RegExp(config.createMaxCharValidator.regex).test(value)
        ) {
          record.addError(key, config.createMaxCharValidator.error)
        }
        if (
          value &&
          new RegExp(config.createEmptyValueValidator.regex).test(value)
        ) {
          record.addError(key, config.createEmptyValueValidator.error)
        }
      }
    )
  )

  listener.use(
    externalConstraint(
      notificationServicesFields.COMPANY_CONTACT_PHONE.key,
      (value, key, { config, record }) => {
        if (
          value &&
          new RegExp(config.createEmptyValueValidator.regex).test(value)
        ) {
          record.addError(key, config.createEmptyValueValidator.error)
        }
        if (
          value &&
          !new RegExp(config.companyContactPhone.regex).test(value)
        ) {
          record.addError(key, config.companyContactPhone.error)
        }
      }
    )
  )

  listener.use(
    externalConstraint(
      notificationServicesFields.COMPANY_WEBSITE.key,
      (value, key, { config, record }) => {
        if (
          value &&
          new RegExp(config.createMaxCharValidator.regex).test(value)
        ) {
          record.addError(key, config.createMaxCharValidator.error)
        }
      }
    )
  )

  listener.use(
    externalConstraint(
      notificationServicesFields.COMPANY_CONTACT_EMAIL.key,
      (value, key, { config, record }) => {
        if (
          value &&
          new RegExp(config.createMaxCharValidator.regex).test(value)
        ) {
          record.addError(key, config.createMaxCharValidator.error)
        }
      }
    )
  )

  iraAmountValidator(
    listener,
    'participant-record',
    [notificationServicesFields.BAL_VESTED.key],
    notificationServicesFields.BAL_TOTAL.key,
    'Balance (vested) or Balance (total) is required'
  )

  iraAmountValidator(
    listener,
    'participant-record',
    [notificationServicesFields.BAL_TOTAL.key],
    notificationServicesFields.BAL_VESTED.key,
    'Balance (vested) or Balance (total) is required'
  )
}
